let originalContainerWidth; // Global scope variable

function initGlideInstance() {
	const carouselBlocks = document.querySelectorAll(".wp-block-zp4-cards-carousel");

    carouselBlocks.forEach((block, index) => {
        block.classList.add(`glide-${index + 1}`);
    });
}

function initCarousel() {
    const carouselBlocks = document.querySelectorAll(".wp-block-zp4-cards-carousel");

    carouselBlocks.forEach((block, index) => {
        new Glide(`.glide-${index + 1}`, {
            type: "carousel",
            gap: 30,
            perView: 1.5,
            breakpoints: {
                640: {
                    gap: 20,
                    perView: 1.25,
                },
            },
        }).mount();
    });
}

function controlContainer() {
	// Create a new div as the control container
	const controlContainer = document.createElement("div");
	controlContainer.classList.add("carousel-control-container");
	controlContainer.style.maxWidth = "117rem";
	controlContainer.style.margin = "auto";

	// Select the .wp-block-zp4-cards element
	const cardsElement = document.querySelector(".wp-block-zp4-cards-carousel");

	// Insert the control container before the cards element
	if (cardsElement) {
		cardsElement.parentNode.insertBefore(controlContainer, cardsElement);
	}
}

function containerOffset() {
	const containerElement = document.querySelector(".wp-block-zp4-cards-carousel");

	if (!originalContainerWidth) {
		// Store the original width the first time this function is called
		originalContainerWidth = containerElement.offsetWidth;
	}

	const windowWidth = window.innerWidth;
	const controlContainerWidth = document.querySelector(".carousel-control-container").offsetWidth;
	const marginOffsetValue = (windowWidth - controlContainerWidth) / 2;

	const newContainerWidth = originalContainerWidth - marginOffsetValue;

	// Block
	containerElement.style.maxWidth = `${newContainerWidth}px`;
	containerElement.style.marginLeft = `${marginOffsetValue}px`;
	containerElement.style.marginRight = "0px";

	// Arrows
	const arrowContainer = document.querySelector(".glide__arrows");
	arrowContainer.style.maxWidth = `${controlContainerWidth}px`;
	arrowContainer.style.marginRight = `${marginOffsetValue}px`;
	arrowContainer.style.marginLeft = `unset`;

	// Logging for debugging
	console.log(`window: ${windowWidth}`);
	console.log(`.control-container: ${controlContainerWidth}`);
	console.log(`margin value: ${marginOffsetValue}`);
	console.log(`new glide width: ${newContainerWidth}`);
}

window.addEventListener(
	"load",
	function () {
		initGlideInstance();
		controlContainer();
		containerOffset();
		initCarousel();
	},
	false
);

window.addEventListener("resize", function () {
	containerOffset();
});
